
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/microsoft-teams",
      function () {
        return require("private-next-pages/microsoft-teams.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/microsoft-teams"])
      });
    }
  